import React, { useState, useEffect } from 'react';
import Layout from '../layout/Layout';
import { Grid, Typography } from '@mui/material';
import { FaRankingStar } from 'react-icons/fa6';
import { GrHomeRounded } from 'react-icons/gr';
import './rankings.css';
import TablaResets from './TablaResets';
import TablaSDLF from './TablaSDLF';
import TablaPK from './TablaPK';
import TablaGuilds from './TablaGuilds';

const menuOptions = {
  resets: {
    label: 'Resets',
    url: 'https://muserendipia.com/gate/rankings/resets',
    component: TablaResets,
  },
  sdlf: {
    label: 'Salón de la fama',
    url: 'https://muserendipia.com/gate/rankings/sdlf',
    component: TablaSDLF,
  },
  phonomanias: {
    label: 'Phonomanias',
    url: 'https://muserendipia.com/gate/rankings/pk',
    component: TablaPK,
  },
  guilds: {
    label: 'Guilds',
    url: 'https://muserendipia.com/gate/rankings/guilds',
    component: TablaGuilds,
  },
};

function Rankings(props) {
  const [activeItem, setActiveItem] = useState('resets');
  const [jugadores, setJugadores] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(menuOptions[activeItem].url);
        const data = await response.json();
        setJugadores(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [activeItem]);

  const handleMenuItemClick = (menuItem) => {
    setActiveItem(menuItem);
  };

  return (
    <Layout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded} isMobile={props.isMobile}>
      <Grid style={{ display: 'flex', flexDirection: 'column', gap: '35px', padding: props.isMobile ? '2rem 1rem' : '2rem 5.8rem'  }}>
        <Typography style={{ color: 'white', fontSize: '20px', display: 'flex', gap: '5px', alignItems: 'center' }}> <FaRankingStar style={{ color: '#856ffc' }} />
          Rankings</Typography>

        <div className="usersettings-navbar">
          <Grid>
            <Grid style={{ display: 'flex', flexDirection: props.isMobile && 'column', padding: '5px 5px', backgroundColor: '#2a2e38', borderRadius: '5px', gap: '15px', width: props.isMobile ? '100%' :'50%' }} className='menu-rankings'>
              {Object.keys(menuOptions).map((menuItem) => (
                <Grid key={menuItem} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px' }} className={activeItem === menuItem ? "item-config-active" : "item-config"} onClick={() => handleMenuItemClick(menuItem)}>
                  <GrHomeRounded style={{ color: 'white' }} />
                  <Typography style={{ color: 'white' }}>{menuOptions[menuItem].label}</Typography>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </div>

        {jugadores.length > 0 && React.createElement(menuOptions[activeItem].component, { jugadores })}
      </Grid>
    </Layout>
  );
}

export default Rankings;
